import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar-subtitle" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.size)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.utils.humanFileSize(_ctx.size)), 1))
      : _createCommentVNode("", true),
    (_ctx.mtime)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.utils.getFromNowStr(new Date(_ctx.mtime * 1000))), 1))
      : _createCommentVNode("", true)
  ]))
}